import {useApi} from '@/services/useApi';
import {defineStore} from 'pinia';
import {getAuthenticatedRequest} from '@/stores/AuthenticatedRequest.js';

export const useWatchdogStore = defineStore('watchdog', {
  state: () => ({
    filter: {
      games: [],
      stores: []
    }
  }),
  getters: {
    isFilterActive(state) {
      return state.filter.games.length > 0 || state.filter.stores.length > 0
    },
    activeFilterCount(state) {
      let count = 0
      if (state.filter.games.length > 0) count ++
      if (state.filter.stores.length > 0) count ++
      return count
    },
  },
  actions: {
    async action_getOffers() {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2083
      };
      //console.log('action_getOffers Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_getOffers Success: ', response);
          return {
            result: true,
            data: response.data.watchdogs
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_addOffer(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2085,
        "watchdog": payload
      };
      //console.log('action_addOffer Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_addOffer Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_updateOffer(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2086,
        "watchdog": payload
      };
      //console.log('action_updateOffer Request: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_updateOffer Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_swapTracker(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2091,
        "watchdog": {
          "offerID": payload.offerID,
          "trackerID": payload.trackerID,
          "newOfferID": payload.newOfferID
        }
      };
      console.log('action_swapTracker Request: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_swapTracker Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_removeTracker(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2090,
        "watchdog": {
          "offerID": payload.offerID,
          "trackerID": payload.trackerID
        }
      };
      console.log('action_removeTracker Request: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_removeTracker Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_addTracker(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2089,
        "watchdog": {
          "offerID": payload.offerID,
          "trackerID": payload.trackerID
        }
      };
      console.log('action_addTracker Request: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_addTracker Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_removeOffer(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 2087,
        "watchdog": {
          "offerID": payload.offerID
        }
      };
      console.log('action_removeOffer Request: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_removeOffer Success: ', response);
          return {
            result: true,
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    getFilteredOffers(offers, searchTerm = '') {
      if (!offers?.length) return []

      const term = searchTerm.toLowerCase().trim()
      const { games, stores } = this.filter

      return offers.filter(offer => {
        if (games.length && !games.includes(offer.game)) {
          return false
        }

        if (stores.length) {
          const offerStoreMatch = stores.includes(offer.store)
          const trackerStoreMatch = offer.trackers?.some(t => stores.includes(t.store))
          if (!offerStoreMatch && !trackerStoreMatch) {
            return false
          }
        }

        if (!term) return true

        const offerMatch =
          (offer.title || '').toLowerCase().includes(term) ||
          (offer.store || '').toLowerCase().includes(term) ||
          (offer.game || '').toLowerCase().includes(term) ||
          String(offer.offerID || '').toLowerCase().includes(term)

        if (offerMatch) return true

        return offer.trackers?.some(tracker =>
          (tracker.title || '').toLowerCase().includes(term) ||
          (tracker.store || '').toLowerCase().includes(term) ||
          String(tracker.trackerID || '').toLowerCase().includes(term) ||
          String(tracker.offerID || '').toLowerCase().includes(term)
        )
      })
    },
  }
});
